import { Component, Input } from '@angular/core';
import { environment } from '@env/environment';

@Component({
  selector: 'app-price-format',
  templateUrl: './price-format.component.html',
  styleUrls: ['./price-format.component.scss'],
})
export class PriceFormatComponent {
  @Input() keepValue: boolean = false;
  @Input() price: number;
  @Input() styleClass: string;
  @Input() justifyContentClass = 'justify-center';
  currentCurrency: any;
  @Input() currency: string | undefined;

  ngOnInit(): void {
    this.currentCurrency =
      JSON.parse(localStorage.getItem(environment.CURRENCY_CONVERSATION_DATA) || '')?.currency ||
      'USD';
  }

  formatPrice(price: number): string {
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.currency ? this.currency : this.currentCurrency,
    }).format(price);
    return formattedPrice;
  }
}
